<template>
  <Dialog v-model:visible="showDialog" :modal="true" :header="model
    ? $t('createItemConfiguration.EditCreate')
    : $t('createItemConfiguration.Create')
    " :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }" @after-hide="IsClear">
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8">
          <div class="field">
            <CustomDropDown v-model="insert_data.ICTypeId" :label="$t('createItemConfiguration.Type')"
              :items="TypeDropDown.TypeOption" :rules="{ required: true }" name="Type" id="Type" :required-icon="true"
              @update:modelValue="" />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField v-model="insert_data.Name" type="number" :label="$t('createItemConfiguration.Name')" clearable
              id="Name" name="Name" :rules="{ required: true }" :required-icon="true" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <CustomTextArea v-model="insert_data.Description" :requiredIcon="false" placeholder=" " name="Description"
              id="Description" :label="$t('createItemConfiguration.Description')" :rules="{ required: false }" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer @cancel="IsClear()" :cancelhide="false" :label="label" :loading="Saveloading" />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist selectedcontent="Already Exist" :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/ItemConfiguration";
import { useRoute } from "vue-router";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../../../components/FormComponents/Dropdown.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomTextArea from "../../../../../../components/FormComponents/TextArea.vue";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    CustomDropDown,
    CustomTextArea,
  },
  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);

    let UserId = Number(session.UserId);

    // let EntityData = localStorage.getItem("EntityData");
    let Entity = ref(props.EntityId);
    // if (EntityData !== null) {
    //   Entity = JSON.parse(EntityData);
    // }

    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let Saveloading = ref(false);
    const alreadyexistpop = ref(false);

    let TypeDropDown = ref({
      TypeOption: [],
    });

    const insert_data = ref({
      Id: 0,
      ICTypeId: ref(),
      Name: "",
      Description: "",
      HospitalId: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      EntityId: Entity.value,
      EntityOperationId: 0,
    });

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      LoadTypes();
    });

    // Load Types
    async function LoadTypes() {
      debugger;
      const response = await service.ListItemConfigTypes();
      TypeDropDown.value.TypeOption = response["result"].map((item) => {
        item.name = item.Type;
        item.value = item.Id;
        return item;
      });
    }

    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      }
    }

    //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      insert_data.value.Id = 0;
      showDialog.value = false;
      emit("update:selectedItem", undefined);
      emit("close");
    }

    // Add New PopUp
    function IsCreate() {
      debugger;
      showDialog.value = true;
    }

    //Row Edit
    async function IsEdit() {
      debugger;
      try {
        label.value = t("btn.update");
        const EditId = model.value.Id;

        const response = await service.Edit(EditId);
        const data = response["result"];
        console.log(response["result"]);
        insert_data.value.Id = data.Id;
        LoadTypes();
        insert_data.value.ICTypeId = data.ICTypeId;
        insert_data.value.Name = data.Name;
        insert_data.value.Description = data.Description;

        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }

    //Save
    const IsSubmit = async () => {
      debugger;
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        let msg = "";
        insert_data.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        insert_data.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );

        insert_data.value.HospitalId = HospitalId;

        let objinsert = Object.assign(insert_data.value);

        if (insert_data.value.Id != 0) {
          insert_data.value.ModifiedBy = UserId;
          insert_data.value.EntityOperationId = 3071002;

          const data_response = await service.Update(insert_data.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          insert_data.value.CreatedBy = UserId;
          insert_data.value.EntityOperationId = 3071001;

          const data_response = await service.insert(insert_data.value);
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == "Already" && msg == null) {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (msg == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        Saveloading.value = false;
        emit("loaderhide");
        alert(error);
      }
    };

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
    }

    return {
      model,
      showModal: ref(false),
      insert_data,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,
      successpop,
      updatepop,
      closetrigger,
      label,
      Saveloading,
      TypeDropDown,
      alreadyexistpop,
      alreadyclosetrigger,
    };
  },
});
</script>
